module.exports = __webpack_public_path__ + "img/scale-unbalanced-flip.7fc07d8e.svg";